import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Home,
  ArrowLeft,
  Wrench,
  Paintbrush,
  Plug,
  Droplets,
  Hammer,
} from "lucide-react";
import { Button } from "../../components/ui/button";
import { Logo } from "../../components/layout/Logo";

const floatingIcons = [
  {
    Icon: Wrench,
    className: "top-[15%] left-[10%] rotate-[-15deg]",
    delay: "0s",
  },
  {
    Icon: Paintbrush,
    className: "top-[20%] right-[12%] rotate-[20deg]",
    delay: "0.5s",
  },
  {
    Icon: Plug,
    className: "bottom-[25%] left-[14%] rotate-[10deg]",
    delay: "1s",
  },
  {
    Icon: Droplets,
    className: "bottom-[20%] right-[10%] rotate-[-10deg]",
    delay: "1.5s",
  },
  {
    Icon: Hammer,
    className: "top-[45%] right-[6%] rotate-[25deg]",
    delay: "0.8s",
  },
];

const NotFoundPage = () => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div
      className={`hero-content ${isVisible ? "fade-in" : ""}`}
      style={{ minHeight: "calc(100vh - 56px)" }}
    >
      <section className="relative min-h-[80vh] flex flex-col items-center justify-center pt-[56px] px-6 overflow-hidden">
        {/* Floating service icons */}
        {floatingIcons.map(({ Icon, className, delay }, i) => (
          <div
            key={i}
            className={`absolute ${className} opacity-0`}
            style={{
              animation: `floatIcon 3s ease-in-out infinite, fadeInIcon 0.6s ease-out ${delay} forwards`,
              animationDelay: `${delay}, ${delay}`,
            }}
          >
            <Icon className="h-8 w-8 text-slate-200" strokeWidth={1.5} />
          </div>
        ))}

        <div className="max-w-md mx-auto text-center relative z-10">
          <Logo className="h-10 w-auto mx-auto mb-8" />

          <p className="text-8xl font-serif font-bold text-slate-900 mb-2">
            404
          </p>
          <p className="text-lg text-slate-500 mb-1">Page not found</p>
          <p className="text-sm text-slate-400 mb-10">
            We looked everywhere — even behind the drywall.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Button asChild size="lg">
              <Link to="/">
                <Home className="mr-2 h-4 w-4" />
                Go home
              </Link>
            </Button>
            <Button variant="outline" size="lg" onClick={() => navigate(-1)}>
              <ArrowLeft className="mr-2 h-4 w-4" />
              Go back
            </Button>
          </div>
        </div>
      </section>

      <style>{`
        @keyframes floatIcon {
          0%, 100% { transform: translateY(0px) rotate(var(--tw-rotate, 0deg)); }
          50% { transform: translateY(-12px) rotate(var(--tw-rotate, 0deg)); }
        }
        @keyframes fadeInIcon {
          from { opacity: 0; transform: scale(0.8); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
};

export default NotFoundPage;
